<template>
  <div class="w-100">
    <div v-for="(journalEntry, index) in journalEntries" :key="index">
      <journalItem
        :indexProperty="index"
        :journalEntryProperty="journalEntry"
        :loggedIn="loggedIn"
        @savejournalentry="saveJournalEntry"
        :tp="tp"
      ></journalItem>
    </div>
    <hr />
    <div v-if="editMessageVisible">
      <journalEntryComponent
        :journalEntryProperty="editJournalEntry"
        :loggedIn="false"
        :tp="tp"
      ></journalEntryComponent>
    </div>
  </div>
</template>

<script>
import { emptyJournalEntry } from "@/common/constants";
import journalItem from "@/components/journal/JournalItem.vue";
import journalEntryComponent from "@/components/journal/JournalEntryComponent.vue";

export default {
  name: "journalComponent",
  components: {
    journalItem,
    journalEntryComponent
  },
  data: function() {
    return {
      tibModel: null,
      journalEntries: [],
      editJournalEntry: null,
      editMessageVisible: false
    };
  },
  mounted() {
    this.tibModel = this.tibModelProperty;
    this.prepareJournalEntry();
    if (this.tibModel) {
      this.loadJournalEntries();
    } else {
      this.journalEntries = this.journalEntriesProperty;
    }
  },
  watch: {
    journalEntriesProperty() {
      this.journalEntries = this.journalEntriesProperty;
    },
    "tibModel.journal": function() {
      this.loadJournalEntries();
    }
  },
  methods: {
    newMessage(text) {
      this.prepareJournalEntry();
      this.editJournalEntry.text = text;
      this.editMessageVisible = true;
    },
    prepareJournalEntry() {
      this.editJournalEntry = JSON.parse(JSON.stringify(emptyJournalEntry));
    },
    saveJournalEntry(entry) {
      this.$emit("savejournalentry", entry);
    },
    loadJournalEntries() {
      if (this.tibModel.journal.startsWith("{")) {
        this.journalEntries = JSON.parse(this.tibModel.journal).entries;
        if (!Array.isArray(this.journalEntries)) {
          this.journalEntries = [];
        } else {
          console.info(
            "journal entries from tib loaded: " + this.journalEntries.length
          );
        }
      }
    }
  },
  props: {
    tibModelProperty: Object,
    journalEntriesProperty: Array,
    loggedIn: false,
    tp: Object
  }
};
</script>
